import { render, staticRenderFns } from "./reactive-references.vue?vue&type=template&id=7caf2984&"
import script from "./reactive-references.vue?vue&type=script&lang=js&"
export * from "./reactive-references.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports